/**
 * Centralized rule-store reset for starting a fresh event session. The store is
 * per `PlanDetails` session and outlives individual event/promo forms, so any
 * entry into an event (add or edit) must clear the prior session's working set
 * to stop `useRuleBoundForm` hydrate-on-mount from replaying stale values.
 */
import { useCallback } from 'react';

import { useOptionalRuleStoreApi } from './FieldRulesProvider';

export function useResetRuleSession() {
    const store = useOptionalRuleStoreApi();

    /** Clears the event working set, every promo instance, and ctx (keeps planYear). */
    const resetEventSession = useCallback(() => {
        const api = store?.getState();
        if (!api) return;
        api.resetScope('event');
        api.resetAllPromo();
        api.resetContext();
    }, [store]);

    return { resetEventSession };
}
